import { ISalesDesignationView } from '../components/articleTileGrid/article-tile/article-tile.d';

const mobileToggleTopic = 'ArticleTileService.Mobile.ToggleTouchPointOnTile';
const mobileToggleSignature = 'ArticleTileService.Mobile.ToggleTouchPointOnTile_ForAts';

export default class TouchPointFactory {
    private static _instance: TouchPointFactory;

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    // published by the MPC toolbar button on tablet and mobile devices to show/hide the touch points of all tiles.
    // the shell keeps only the last handler per signature, so subscribe once per page and not once per grid:
    public subscribeToMobileToggle(onToggle: () => void): void {
        if (typeof window !== 'undefined' && window.shell)
            window.shell.subscribeTo(mobileToggleTopic, onToggle, mobileToggleSignature);
    }

    public unsubscribeFromMobileToggle(): void {
        if (typeof window !== 'undefined' && window.shell)
            window.shell.unsubscribeFrom(mobileToggleTopic, mobileToggleSignature);
    }

    public createTouchPointsBatch(newArticles: ISalesDesignationView[]): void {
        if(!newArticles || newArticles.length <= 0)
            return;

        const savKeyArray: {savKey: string; seoSlug: string; displayedInCategoryNavKey: string;} [] = [];
        newArticles.forEach((art) => {
            const defaults =
            art.salesArticleVariantColors.filter(it => it.salesArticleVariantKey === art.defaultSalesArticleVariantKey);

            if(defaults.length >= 1)
                savKeyArray.push({savKey: defaults[0].salesArticleVariantKey, 
                displayedInCategoryNavKey: art.navigationKey, seoSlug: art.seoSlug});
        });

        if (window.shell && savKeyArray.length > 0)
            window.shell.publishTo('ManualProductComparison.CreateTouchPointsBatch', savKeyArray);
    }
}
